import React from 'react';
import Grid from '@mui/material/Grid';
function createresume() {
    return (
        <div className="resumebg">
            <div className="crresume">
                <p className="fisrtre">Customization Made Simple</p>
                <p className="secondre">Create a resume to land your next job</p>
                <p className="thirdre">Put the focus on your experience, skills, and knowledge when you build your resume online with us. Simply select our contemporary template to give yourself an edge. Try a few different styles in your resume maker and you will soon find the perfect one to showcase your skills & experience in a best way.</p>
                <p><button className="crrbtn" type="button">Build Your Resume With Us &gt;</button></p>
            </div>
        </div>
    );
}

export default createresume;
